import { ImageMap, getImage, importAll } from "..";

declare const require: any;

const imagesCulture: ImageMap = importAll(
  require.context("../culture", false, /\.(png|jpe?g|svg)$/)
);

export default imagesCulture;
export const getTemplateCultureImg = (valueTemplateImage: string) => {
  const filteredImages = Object.entries(imagesCulture).find(
    ([item, value], index) => getImage(item) === valueTemplateImage
  );
  if (filteredImages) return filteredImages[1];
  else return "";
};
